// ПОДКЛЮЧЕНИЕ ПЕРЕМЕННЫХ
import Swiper from 'swiper';
// НАДСТРОЙКА ДЛЯ БУТСТРАП СЛАЙДЕРА
$('.carousel-item:first-of-type').attr('class', 'active carousel-item');
$('.carousel-item2:first-of-type').attr('class', 'active carousel-item');
// АКТИВНЫЙ ПУНКТ МЕНЮ
$(document).ready(function () {
    $(".record-list-li").click(function () {
        $(".record-list-li").removeClass('active');
        $(this).toggleClass('active');
    });
});
// КРАСИВЫЕ ПЛЕЙСХОЛДЕРЫ
$(document).ready(function () {
    $(".email").inputmask("email")
});
$(document).ready(function () {
    $(".phone").mask("+7 (999) 99-99-999");
});
(function ($) {
    $('#MoviesFilter').on('change', 'input, select', function () {
        var $form = $(this).closest('form');
        $form.request();
    });
})(jQuery);
// АКТИВАЦИЯ ВСПЛЫВАЮЩИХ ОКОН ДЛЯ ИЗОБРАЖЕНИЙ
$(document).ready(function () {
    jQuery(".colorbox").colorbox();
});
// ОТКРЫТЬ ДОП БЛОК
$("#otziv").click(function () {
    $("form").css('display', 'block');
    $(this).css('display', 'none');
});
// ПЕРЕКЛЮЧЕНИЕ МОБИЛЬНОГО МЕНЮ
$(function () {
    $('.display_mobile').on('click', function () {
        $('.display_comp').slideToggle(300, function () {
            if ($(this).css('display') === "none") {
                $(this).removeAttr('style');
            }
        });
        $('.close').slideToggle(300, function () {
            if ($(this).css('display') === "none") {
                $(this).removeAttr('style');
            }
        });
        $('.display_mobile').slideToggle(10, function () {
            if ($(this).css('display') === "block") {
                $(this).css('display', 'none');
            }
            $('.header_logo_mobile_1').css('display', 'none');
        });
        $('.close').on('click', function () {
            $('.display_comp').css('display', 'none');
            $('.close').css('display', 'none');
            $('.display_mobile').css('display', 'block');
            $('.header_logo_mobile_1').css('display', 'flex');
        });
    });
});
// АКТИВАЦИЯ ПАРАЛЛАКС
$('.my-paroller').paroller();
$('.jumbotron').paroller();
// ГЛАВНАЯ СЕКЦИЯ 2
$(".section_2 button").click(function () {
    id = $(this).attr("class");
    $(".section_2 button").css("background", "");
    $(this).css("background", "#0094d2");
    $(".section_2 button").css("color", "");
    $(this).css("color", "white");
    $(".elem_1_2").css("display", "");
    $(".elem_1 #" + id).css("display", "block");
    $(".elem_1_2").css("left", "");
    setTimeout('$(".elem_1 #"+id).css("left","0%")', 10);
});
$(".nav-trigger").click(function () {
    /* Act on the event */
    if ($(".cd-morph-dropdown").hasClass("nav-open")) {
        $(' .section_1 .block_1 .elem_2').css('margin-top', '170px');
    } else {
        $(' .section_1 .block_1 .elem_2').css('margin-top', '20px');
    }
});
// Модальное окно
$("#modal").iziModal();
$(window).on("load", function () {
    setTimeout(function () {
        $(".box_124").css('bottom', '5000px');
    }, 2000);
});
// ДЛЯ ПОДГРУЗКИ БОЛЬШИХ ИЗОБРАЖЕНИЙ
$('.toggle_lump .l').on("change", function () {
    $('.img_toggle_block').find("img").removeClass('greyscale_off'); // using find
    $('.img_toggle_block').removeClass('drop_shadow'); // using find
    $('.card_price').removeClass('border_blue'); // using find
    $('.img_toggle_block').removeClass('opacity'); // using find
    if ($('.toggle_lump .l:checked')) {
        $(this).closest('.img_toggle_block').find("img").toggleClass('greyscale_off'); // using find
        $(this).closest('.img_toggle_block').toggleClass('drop_shadow'); // using find
        $(this).closest('.card_price').toggleClass('border_blue'); // using find
        $(this).closest('.img_toggle_block').toggleClass('opacity'); // using find
    } else {
        $('.img_toggle_block').find("img").removeClass('greyscale_off'); // using find
        $('.img_toggle_block').removeClass('drop_shadow'); // using find
        $('.card_price').removeClass('border_blue'); // using find
        $('.img_toggle_block').removeClass('opacity'); // using find
    }
});
// ПОЯВЛЕНИЕ КАЛЬКУЛЯТОРА
(function ($) {
    $('.toggle_lump .l').on("change", function () {
        $(' .calculator_block').css('display', 'block');
        $('.enot').css('display', 'block');
        var $form = $('#form_result')
        $form.request();
    });
})(jQuery);
// ПОЯВЛЕНИЕ КАЛЬКУЛЯТОРА
(function ($) {
    $('.toggle_lump .v').on("change", function () {
        $(' .calculator_block').css('display', 'block');
        $('.enot').css('display', 'block');
        var $form = $('#form_result')
        $form.request();
    });
})(jQuery);
// Красивая инпуты для формы
$(document.body).on("click", ".form_row_select_helper", function () {
    ($(this).siblings("select"));
});
function openSelect(selector) {
    var element = $(selector)[0], worked = false;
    if (document.createEvent) { // all browsers
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        worked = element.dispatchEvent(e);
    } else if (element.fireEvent) { // ie
        worked = element.fireEvent("onmousedown");
    }
    if (!worked) { // unknown browser / error
        alert("It didn't worked in your browser.");
    }
}
$(document.body).on("focus blur", ".form_row .form_textinput", function (e) {
    switch (e.type) {
        case "focusin":
            $(this).closest(".form_row").addClass("focused");
            break;
        case "focusout":
            $(this).closest(".form_row").removeClass("focused");
            break;
    }
});
$(document.body).on("click", ".form_row.haserror", function () {
    $(this).removeClass("haserror");
});
// ДЛЯ ПОДГРУЗКИ БОЛЬШИХ ИЗОБРАЖЕНИЙ
//  $(document).ready(function() {
//     $('.swiper-slide img').parent('.colorbox').each(function(){
// $(this).attr('href', 'https://domain.ru/storage/app/media/big-img/' + $(this).children().attr('data-srcc').slice(57, 100));
// });
//  });
// РЕГИСТРАЦИЯ И АВТОРИЗАЦИЯ
$('#reg_on').click(function () {
    $('.reg').removeClass('display_none');
    $('.auth').addClass('display_none');
    $('#reg_on').addClass('active_btn');
    $('#auth_on').removeClass('active_btn');
});
$('#auth_on').click(function () {
    $('.auth').removeClass('display_none');
    $('.reg').addClass('display_none');
    $('#auth_on').addClass('active_btn');
    $('#reg_on').removeClass('active_btn');
});
// ТАЙМЕР
setTimeout(function () {
    let timer = $('.timer').attr('id');
    $('.timer').timeTo({
        timeTo: new Date(timer),
        theme: "null",
        displayCaptions: true,
        fontSize: 14,
        lang: 'ru',
        fontFamily: 'Montserrat-SemiBold',
    });
}, 2000);
// ОТКРЫТЬ МЕНЮ В МОБИЛЬНОЙ ВЕРСИИ
$(".active_menu_btn").click(function () {
    $('.header .section_2 .block_1 ul').toggleClass('active_menu');
    $('.close_menu_btn').toggleClass('close_menu_btn_active');
});
// ЗАКРЫТЬ МЕНЮ В МОБИЛЬНОЙ ВЕРСИИ
$(".close_menu_btn").click(function () {
    $('.header .section_2 .block_1 ul').toggleClass('active_menu');
    $('.close_menu_btn').toggleClass('close_menu_btn_active');
});
// ПОИСК
$("#search_btn").click(function () {
    $('#result').toggleClass('active_search');
    $('.close_search').toggleClass('d_block');
});
$(".close_search").click(function () {
    $('#result').removeClass('active_search');
    $(this).removeClass('d_block');
});
// ДОБАВИТЬ В ИЗБРАННОЕ
$("._shopaholic-add-wish-list-button").click(function () {
    alert('Изменился статус товара в разделе "Избранное"');
});
// ВСПЛЫВАЮЩЕЕ ОКНО ДОБАВЛЕНИЯ В КОРЗИНУ
$(".tooltip product-info__tooltip ").click(function () {
    $(".tooltip").toggleClass('opacity');
});
// ОТКРЫТИЕ БОНУСНЫЕ ПРОГРАММЫ
$(".bonus-page .elem").on("click", function () {


    $(this).find(".bonus_description").toggleClass('adv_my');

});
// ОТЗЫВЫ
$(".social_send_toggle").click(function () {
    $('.social_send').toggleClass('d_flex');
});
// КОРЗИНА ПУСТА
$(".cart-info_empty").click(function () {
    alert('Корзина пуста');
});
// УМНЫЙ ПОИСК ПО ДОКУМЕНТАМ
$('select').change(function () {
    $('#result').removeClass('active_search');
    $('.close_search').removeClass('d_block');
});
$('.e select').change(function () {
    $("option").toggleClass('select-active');
    pause(3000);
    if ($("select[name='otraslprava']").val() == 'Семейное') {
        $("option[value='Установление отцовства']").toggleClass('select-active');
        $("option[value='Расторжение брака']").toggleClass('select-active');
        $("option[value='Раздел имущества']").toggleClass('select-active');
        $("option[value='Признание брака недействительным']").toggleClass('select-active');
        $("option[value='Право собственности']").toggleClass('select-active');
    }
});
// Слайдеры
// СЛАЙДЕР С ЛОГОТИПАМИ
var mySwiper = new Swiper('.swiper-container_logo', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 8,
    spaceBetween: 80,
    breakpoints: {
        992: {
            slidesPerView: 8,
            spaceBetween: 10
        },
        767: {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            centeredSlides: true
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            centeredSlides: true
        }
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next-logo',
        prevEl: '.swiper-button-prev-logo',
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});
// СЛАЙДЕР С САМЫМИ ПОПУЛЯРНЫМИ ТОВАРАМИ ЗА ГОД
var mySwiper2 = new Swiper('.container_year', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'flip',
    grabCursor: true,
    autoplay: {
        delay: 5000,
    },
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});
// СЛАЙДЕР НОВИНКИ
var mySwiper2 = new Swiper('.container_news_products', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 3,
    grabCursor: true,
    spaceBetween: 20,
    autoplay: {
        delay: 500000,
    },
    breakpoints: {
        992: {
            slidesPerView: 3,
            spaceBetween: 10
        },
        767: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 10
        }
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});
// СЛАЙДЕР РЕКОМЕНДУЕМЫЕ ТОВАРЫ
var mySwiper2 = new Swiper('.container_recommend_products', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 4,
    grabCursor: true,
    spaceBetween: 20,
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        992: {
            slidesPerView: 4,
            spaceBetween: 20
        },
        767: {
            slidesPerView: 1,
            spaceBetween: 20
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0
        }
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});



// СЛАЙДЕР ПОПУЛЯРНЫЕ ТОВАРЫ НА СТРАНИЦЕ ТОВАРА
var mySwiper = new Swiper('.swiper-5', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 5,
    spaceBetween: 30,
    breakpoints: {
        1200: {
            slidesPerView: 5,
            spaceBetween: 30
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 30
        },
        767: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0
        }
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});
var mySwiper = new Swiper('.swiper_container_adv_products', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 3,
    spaceBetween: 15,
    breakpoints: {
        1200: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        767: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0
        }
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});
// СЛАЙДЕР ПОПУЛЯРНЫЕ ПОКУПКИ
var mySwiper = new Swiper('.container_category_slider_products', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // Default parameters
    slidesPerView: 5,
    spaceBetween: 30,
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        1200: {
            slidesPerView: 5,
            spaceBetween: 30
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 30
        },
        767: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0
        }
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
});
var swiper = new Swiper('.swiper-main-slider', {
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    autoplay: {
        delay: 5000,
    },
});

